import { ReferralType } from '@dreryk/egabinet-referral-frontend-api';

import { useInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { sidePanelTranslationKeys } from '../../translations';

import { StyledHistoricalVisitElectronicDocumentItemWrapper } from './HistoricalVisitElectronicDocumentItem.styled';

type HistoricalVisitElectronicReferralProps = {
   readonly referralType: ReferralType;
   readonly code: string;
};

const HistoricalVisitElectronicReferral = (props: HistoricalVisitElectronicReferralProps): JSX.Element => {
   const translate = useTranslate();
   const interpolatedKey = useInterpolatedTranslationKey(
      'visit:sidePanel:historicalVisits:historicalVisit:electronicReferralItem',
      {
         type: translate(
            sidePanelTranslationKeys.historicalVisits.historicalVisit.electronicReferralType[props.referralType]
         ),
         code: props.code
            ? props.code
            : translate('visit:sidePanel:historicalVisits:historicalVisit:electronicReferralNoCode'),
      }
   );

   return (
      <StyledHistoricalVisitElectronicDocumentItemWrapper>
         <p>{translate(interpolatedKey)}</p>
      </StyledHistoricalVisitElectronicDocumentItemWrapper>
   );
};

export { HistoricalVisitElectronicReferral };
